import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function CopyBaseCardColorButtonLayout(props) {
	const { t } = useTranslation();

	return (
		<ActionButtonLayout {...props}>
			{t("buttonName.copyBaseCardColor")}
		</ActionButtonLayout>
	);
}

export default CopyBaseCardColorButtonLayout;
